/**
 * @flow
 * @relayHash e42089e3154b9036873cc92270a070ce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type onlineStorePage_onlineStore$ref = any;
export type srcOnlineStoreQueryVariables = {||};
export type srcOnlineStoreQueryResponse = {|
  +onlineStore: {|
    +$fragmentRefs: onlineStorePage_onlineStore$ref
  |}
|};
export type srcOnlineStoreQuery = {|
  variables: srcOnlineStoreQueryVariables,
  response: srcOnlineStoreQueryResponse,
|};
*/


/*
query srcOnlineStoreQuery {
  onlineStore {
    ...onlineStorePage_onlineStore
  }
}

fragment onlineStorePage_onlineStore on OnlineStore {
  title
  description
  picture
  promotedProduct {
    headerPicture
    description
    callToAction
    color
    textColor
    product {
      slug
      picture
      shopifyProduct
      city {
        slug
        color
      }
    }
  }
  seo {
    title
    description
  }
  social {
    twitter {
      type
      title
      image
      handle
      description
    }
    generic {
      title
      image
      description
    }
  }
  productsSlugs {
    slug
    name
  }
  products {
    ...productPreview_product
  }
}

fragment productPreview_product on Product {
  slug
  name
  picture
  shopifyProduct
  city {
    color
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shopifyProduct",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcOnlineStoreQuery",
  "id": null,
  "text": "query srcOnlineStoreQuery {\n  onlineStore {\n    ...onlineStorePage_onlineStore\n  }\n}\n\nfragment onlineStorePage_onlineStore on OnlineStore {\n  title\n  description\n  picture\n  promotedProduct {\n    headerPicture\n    description\n    callToAction\n    color\n    textColor\n    product {\n      slug\n      picture\n      shopifyProduct\n      city {\n        slug\n        color\n      }\n    }\n  }\n  seo {\n    title\n    description\n  }\n  social {\n    twitter {\n      type\n      title\n      image\n      handle\n      description\n    }\n    generic {\n      title\n      image\n      description\n    }\n  }\n  productsSlugs {\n    slug\n    name\n  }\n  products {\n    ...productPreview_product\n  }\n}\n\nfragment productPreview_product on Product {\n  slug\n  name\n  picture\n  shopifyProduct\n  city {\n    color\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcOnlineStoreQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "onlineStore",
        "storageKey": null,
        "args": null,
        "concreteType": "OnlineStore",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "onlineStorePage_onlineStore",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcOnlineStoreQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "onlineStore",
        "storageKey": null,
        "args": null,
        "concreteType": "OnlineStore",
        "plural": false,
        "selections": [
          v0,
          v1,
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "promotedProduct",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductPromotion",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "headerPicture",
                "args": null,
                "storageKey": null
              },
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "callToAction",
                "args": null,
                "storageKey": null
              },
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "textColor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  v4,
                  v2,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "city",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "City",
                    "plural": false,
                    "selections": [
                      v4,
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v0,
              v1
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  v0,
                  v6,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v1
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v0,
                  v6,
                  v1
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "productsSlugs",
            "storageKey": null,
            "args": null,
            "concreteType": "Product",
            "plural": true,
            "selections": [
              v4,
              v7
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "products",
            "storageKey": null,
            "args": null,
            "concreteType": "Product",
            "plural": true,
            "selections": [
              v4,
              v7,
              v2,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "City",
                "plural": false,
                "selections": [
                  v3
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '76bcc2c4a5257d7df448d8c29155db2d';
module.exports = node;
